<template>
  <div class="trx-kartu-prakerja">
    <BlNavBarMv style="border-bottom: 1px solid #ebebeb" title="Transaksi" has-back-button @handleBackButtonClick="onClickBack" />
    <BlTabsMv :tabs="tabs" :active-tab-name.sync="activeTabName">
      <BlTabNavMv slot="tab-nav-prakerja" title="Prakerja" />
      <BlTabContentMv slot="tab-content-prakerja">
        <PrakerjaTransactionList />
      </BlTabContentMv>

      <BlTabNavMv slot="tab-nav-edukarier" title="Edukarier" />
      <BlTabContentMv slot="tab-content-edukarier">
        <EdukarierTransactionList />
      </BlTabContentMv>
    </BlTabsMv>
  </div>
</template>

<script>
import {BlNavBarMv, BlTabsMv, BlTabNavMv, BlTabContentMv} from '@bukalapak/bazaar-mweb-latest';
import PrakerjaTransactionList from 'shared/components/PrakerjaEdukarier/organisms/PrakerjaTransactionList.vue';
import EdukarierTransactionList from 'shared/components/PrakerjaEdukarier/organisms/EdukarierTransactionList.vue';
import nativeHandler from 'src/shared/mixins/native-handler';

export default {
  name: 'PrakerjaTransactionListPage',
  components: {
    BlNavBarMv,
    BlTabsMv,
    BlTabNavMv,
    BlTabContentMv,
    PrakerjaTransactionList,
    EdukarierTransactionList,
  },
  mixins: [nativeHandler],
  data() {
    return {
      isLoading: false,
      transactionList: [],
      activeTabName: 'prakerja',
      tabs: ['prakerja', 'edukarier'],
    };
  },
  computed: {
    isLogin() {
      return window.USER.id !== '' && window.USER.id !== null;
    },
  },
  mounted() {
    if (!this.isLogin) {
      this.$router.replace({name: 'landing'});
    }
  },
  methods: {
    onClickBack() {
      this.backNative(() => {
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: calc(100vh - 58px);
  padding: 16px;
}
</style>
